import { experimentAtom, experimentOverrideAtom } from '@/atoms/Auth';
import { useAtomValue } from 'jotai';
export function useExperimentVariant(experimentName) {
    var _a, _b;
    const experiments = useAtomValue(experimentAtom);
    const overrides = useAtomValue(experimentOverrideAtom);
    // 오버라이드가 있으면 우선 적용 (DevTool에서 설정)
    if (overrides[experimentName]) {
        return overrides[experimentName];
    }
    return (_b = (_a = experiments === null || experiments === void 0 ? void 0 : experiments[experimentName]) === null || _a === void 0 ? void 0 : _a.variant) !== null && _b !== void 0 ? _b : 'CONTROL';
}
/** 도움돼요 버튼 A/B 테스트: TREATMENT_1이면 아이콘만 버튼 */
export function useIsUpvoteIconOnly() {
    return useExperimentVariant('UPVOTE_BUTTON_STYLE') === 'TREATMENT_1';
}
